import { REPORTING_TRANSACTIONS } from '../actionTypes';

export const fetchTransactionsReporting = (payload) => ({
  type: REPORTING_TRANSACTIONS.FETCH,
  payload,
});
